import { render, staticRenderFns } from "./customization.vue?vue&type=template&id=a96f518c&scoped=true&"
import script from "./customization.vue?vue&type=script&lang=js&"
export * from "./customization.vue?vue&type=script&lang=js&"
import style0 from "./customization.vue?vue&type=style&index=0&id=a96f518c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96f518c",
  null
  
)

export default component.exports